import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M12 2a1 1 0 011 1v1.28l5 1.67 2.68-.9a1.002 1.002 0 11.64 1.9l-2.053.683 2.683 8.047a1 1 0 01-.4 1.15A6.36 6.36 0 0118 18c-1.2 0-2.4-.4-3.55-1.17a1 1 0 01-.4-1.15l2.681-8.047L13 6.39V18c0 1.1.9 2 2 2h1v2H8v-2h1a2 2 0 002-2V6.39L7.267 7.633 9.95 15.68a1 1 0 01-.4 1.15A6.36 6.36 0 016 18c-1.2 0-2.4-.4-3.55-1.17a1 1 0 01-.4-1.15l2.681-8.047L2.68 6.95a1.002 1.002 0 01.64-1.9l2.68.9 5-1.67V3a1 1 0 011-1zm6 8.16L16.39 15h3.22L18 10.16zm-12 0L4.39 15h3.22L6 10.16z",
      fill: "#2d6ded"
    }
  )
), t = l;
export {
  t as default
};
